// Thrown by login() when the account has MFA enabled -- the login request
// never reaches a real token, just a short-lived challenge the caller must
// redeem via verifyMfa() with a TOTP code.
export class MfaRequiredError extends Error {
  challengeToken: string;

  constructor(challengeToken: string) {
    super("MFA verification required");
    this.name = "MfaRequiredError";
    this.challengeToken = challengeToken;
  }
}
